// Прокидывание UTM/click-меток между страницами на стороне браузера.
// Метки берутся из текущего URL и cookie, затем дописываются ко всем
// внутренним ссылкам. Делается в браузере, чтобы поисковые краулеры
// (без JS) ходили по чистым URL и не плодили дубли в индексе.

const TRACKING_PARAMS = [
    "utm_id",
    "utm_content",
    "utm_medium",
    "utm_campaign",
    "utm_source",
    "utm_term",
    "utm_referrer",
    "gclid",
    "fbclid",
    "msclkid",
];

// Собираем метки только из текущего URL — то, что реально пришло в адресе.
function collectTrackingParams() {
    const fromUrl = new URLSearchParams(window.location.search);
    const params = {};

    TRACKING_PARAMS.forEach(function (key) {
        const value = fromUrl.get(key);
        if (value) {
            params[key] = value;
        }
    });

    return params;
}

function isInternalLink(anchor) {
    const href = anchor.getAttribute("href");

    if (!href) {
        return false;
    }
    // Якоря, спецсхемы и скачивание пропускаем
    if (/^(#|mailto:|tel:|javascript:)/i.test(href)) {
        return false;
    }
    if (anchor.hasAttribute("download")) {
        return false;
    }
    // Только наш домен (относительные ссылки тоже резолвятся в него)
    return anchor.hostname === window.location.hostname;
}

function decorateLinks() {
    const params = collectTrackingParams();
    const keys = Object.keys(params);

    if (!keys.length) {
        return;
    }

    document.querySelectorAll("a[href]").forEach(function (anchor) {
        if (!isInternalLink(anchor)) {
            return;
        }

        const url = new URL(anchor.href, window.location.origin);

        // Не перетираем метки, уже явно проставленные в ссылке
        keys.forEach(function (key) {
            if (!url.searchParams.has(key)) {
                url.searchParams.set(key, params[key]);
            }
        });

        anchor.href = url.toString();
    });
}

document.addEventListener("DOMContentLoaded", decorateLinks);
